import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';

const WhatsAppFloatingButton = () => (
    <a
        href="https://wa.me/263772284402"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 z-50 bg-green-500 hover:bg-green-600 text-white rounded-full shadow-lg p-4 flex items-center justify-center transition-all duration-200"
        aria-label="Chat with us on WhatsApp"
    >
        {FaWhatsapp({ size: 32 })}
    </a>
);

export default WhatsAppFloatingButton; 